/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, connector: NonNullable<unknown> }} Agent_Templates_Required_HintInputs */



/**
* | output |
* | --- |
* | "{name} is built around {connector}. Connect {connector} now and it is added here when you come back, or create it first and turn {connector} on later under A..." |
*
* @param {Agent_Templates_Required_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_templates_required_hint = /** @type {((inputs: Agent_Templates_Required_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Templates_Required_HintInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} ist auf ${i?.connector} ausgelegt. Verbinden Sie ${i?.connector} jetzt, dann wird es hier ergänzt, sobald Sie zurückkommen. Oder legen Sie ihn zuerst an und schalten Sie ${i?.connector} später in den Einstellungen des Agenten unter Fähigkeiten ein.`)
	return /** @type {LocalizedString} */ (`${i?.name} is built around ${i?.connector}. Connect ${i?.connector} now and it is added here when you come back, or create it first and turn ${i?.connector} on later under Abilities in the agent's settings.`)
});